import { Box, Grid, GridItem } from '@chakra-ui/react';
import React from 'react';
import { commonStyle } from '../../../../common/styles';

export type HelpButtonNameType =
  | 'かんたん説明'
  | 'Brief Description'
  | 'マップ'
  | 'Map'
  | 'ボタン'
  | 'Button'
  | '運行情報'
  | 'Streetcar Information'
  | '電車の乗り方'
  | 'How to ride'
  | 'その他'
  | 'Others';

// ボタン内のレイアウトを種類ごとに出し分ける
const getChild = (
  name: HelpButtonNameType,
  selected: boolean,
  onClick: () => void
) => {
  switch (name) {
    case 'Brief Description':
      return (
        <Grid
          gridTemplateRows={`1fr 1fr`}
          w='90%'
          h='90%'
          fontSize='11px'
          bgColor={selected ? '#FBE5D6' : 'white'}
          borderRadius='5px'
          onClick={onClick}
        >
          <GridItem
            gridRow={1}
            sx={{
              ...commonStyle.center,
              alignItems: 'flex-end'
            }}
          >
            {'Brief'}
          </GridItem>
          <GridItem
            gridRow={2}
            sx={{
              ...commonStyle.center,
              alignItems: 'flex-start'
            }}
          >
            {'Description'}
          </GridItem>
        </Grid>
      );

    case 'Streetcar Information':
      return (
        <Grid
          gridTemplateRows={`1fr 1fr`}
          w='90%'
          h='90%'
          fontSize='11px'
          bgColor={selected ? '#FBE5D6' : 'white'}
          borderRadius='5px'
          onClick={onClick}
        >
          <GridItem
            gridRow={1}
            sx={{
              ...commonStyle.center,
              alignItems: 'flex-end'
            }}
          >
            {'Streetcar'}
          </GridItem>
          <GridItem
            gridRow={2}
            sx={{
              ...commonStyle.center,
              alignItems: 'flex-start'
            }}
          >
            {'Information'}
          </GridItem>
        </Grid>
      );

    default:
      return (
        <Box
          w='90%'
          h='90%'
          fontSize='clamp(0.75rem, 0.023rem + 3.64vw, 0.875rem)'
          bgColor={selected ? '#FBE5D6' : 'white'}
          borderRadius='5px'
          cursor='pointer'
          sx={{ ...commonStyle.center }}
          onClick={onClick}
        >
          {name}
        </Box>
      );
  }
};

type Props = {
  name: HelpButtonNameType;
  selected: boolean;
  onClick: () => void;
};

const HelpButton: React.FC<Props> = (props) => {
  const { name, selected, onClick } = props;
  return <>{getChild(name, selected, onClick)}</>;
};

export default React.memo(HelpButton);
